import {
  DEFAULT_GRID_COL_TYPE_KEY,
  getGridDefaultColumnTypes,
  GridColDef,
  GridFilterModel,
} from '@mui/x-data-grid-premium';

const defaultColumnTypes = getGridDefaultColumnTypes();

const getOperatorValuesForColumn = (column: GridColDef): string[] => {
  if (column.filterOperators?.length) {
    return column.filterOperators.map((operator) => operator.value);
  }

  const columnType = column.type ?? DEFAULT_GRID_COL_TYPE_KEY;
  const typeDef = defaultColumnTypes[columnType] ?? defaultColumnTypes[DEFAULT_GRID_COL_TYPE_KEY];

  return typeDef.filterOperators?.map((operator) => operator.value) ?? [];
};

/**
 * Drops filter items that reference unknown columns or unsupported operators.
 * Prevents MUI X from throwing when restoring stale session-storage filter models.
 */
export const sanitizeFilterModel = (
  filterModel: GridFilterModel,
  columns: readonly GridColDef[]
): GridFilterModel => {
  const columnsByField = new Map(columns.map((column) => [column.field, column]));

  const items = filterModel.items.filter((item) => {
    if (!item.field || !item.operator) {
      return false;
    }

    const column = columnsByField.get(item.field);
    if (!column) {
      return false;
    }

    return getOperatorValuesForColumn(column).includes(item.operator);
  });

  if (items.length === filterModel.items.length) {
    return filterModel;
  }

  return { ...filterModel, items };
};
